export default __webpack_public_path__ + "static/reed-5-6305eeaf6079190781b066c7702d0d7f.png";